import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { quartiers } from "../quartiers";

const SITE = "https://loyaris.fr";

const PAGES = {
  "/": {
    title: "Loyaris — Gestion locative à Paris dès 3,60 % TTC",
    description:
      "Confiez la gestion de votre bien à Loyaris : gestionnaire dédié, suivi 100 % digital et assurance loyers impayés MMA. Formules Liberté 3,60 % et Sérénité 4,20 % TTC.",
  },
  "/estimation-loyer": {
    title: "Estimation de loyer gratuite et frais de gestion — Loyaris",
    description:
      "Estimez gratuitement le loyer de votre appartement et calculez vos frais de gestion locative Loyaris en quelques clics. Loyer de marché, encadrement et revenu net.",
  },
  ...Object.fromEntries(quartiers.map((q) => [`/${q.slug}`, { title: q.title, description: q.description }])),
  "/mentions-legales": { title: "Mentions légales — Loyaris", description: "Mentions légales du site Loyaris, agence de gestion locative à Paris 8." },
  "/confidentialite": { title: "Politique de confidentialité — Loyaris", description: "Comment Loyaris collecte, utilise et protège vos données personnelles." },
  "/admin": { title: "Espace admin — Loyaris", description: "Espace admin Loyaris.", noindex: true },
  "/galerie-photos": { title: "Galerie photos — Loyaris", description: "Galerie photos Loyaris.", noindex: true },
};

const upsert = (selector, tag, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export const Seo = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView();
      if (el || ++tries > 30) clearInterval(t);
    }, 100);
    return () => clearInterval(t);
  }, [pathname, hash]);
  useEffect(() => {
    const page = PAGES[pathname] || PAGES["/"];
    const url = `${SITE}${pathname === "/" ? "/" : pathname}`;
    document.title = page.title;
    upsert('meta[name="description"]', "meta", { name: "description", content: page.description });
    upsert('meta[name="robots"]', "meta", { name: "robots", content: page.noindex ? "noindex, follow" : "index, follow" });
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: url });
    upsert('meta[property="og:title"]', "meta", { property: "og:title", content: page.title });
    upsert('meta[property="og:description"]', "meta", { property: "og:description", content: page.description });
    upsert('meta[property="og:url"]', "meta", { property: "og:url", content: url });
  }, [pathname]);
  return null;
};
